import { useTranslation } from 'react-i18next'

import { formatMoney } from 'common'

//
import { ChartDataType, Icon, Pie } from 'common/components'

//
import './statisticCard.less'

type StatisticCardProps = {
  data: ChartDataType[]
  statistics: {
    title: string
    content: string
  }
  allowance: {
    spent: number
    total: number
  }
  // TODO: Make required in the future
  trend?: {
    amount: number
    increasing: boolean
  }
  width?: number
  height?: number
  offerSameAllowance?: boolean
}

const StatisticCard = ({ width = 140, height = 140, ...props }: StatisticCardProps) => {
  const { t } = useTranslation()
  let { data: mutableData, statistics: mutableStatistics } = props

  /**
   * Prevent NaN from appearing in the chart, if the data is not valid,
   * fallback to 0
   */
  mutableData.forEach((item) => {
    item.value = item.value || 0
  })

  mutableStatistics.content = mutableStatistics.content + '%'
  return (
    <div className="statistic-card__wrap">
      <Pie data={props.data} statistics={mutableStatistics} width={width} height={height} />

      <div className="statistic-card__content-wrap">
        {!props.offerSameAllowance && (
          <>
            <p className="statistic-card__pre-title">{t('admin-dashboard.home.statistics.pre-title-label')}</p>
            <p className="statistic-card__title">{formatMoney(props.allowance.spent)}</p>
            <p className="statistic-card__sub-title">
              {t('admin-dashboard.home.statistics.of')} {formatMoney(props.allowance.total)}
            </p>
          </>
        )}
        {props.trend && (
          <p className={`statistic-card__trend ${props.trend.increasing ? 'increasing' : 'decreasing'}`}>
            {t('admin-dashboard.home.statistics.trend-label')}
            <span>
              {formatMoney(props.trend.amount)}%
              {props.trend.increasing ? <Icon className="fa fa-arrow-up" /> : <Icon className="fa fa-arrow-down" />}
            </span>
          </p>
        )}
      </div>
    </div>
  )
}

export default StatisticCard
